import styled from "styled-components";
import { icons } from "../../../data/icons";
import { size } from "../../../style/util/size";

export const StyledIconWrapper = styled.div<{
  $icon: keyof typeof icons;
}>`
  ${size("4rem")};
`;
